import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TokenRefreshService {
    private _isRefreshing = false;
    private readonly _refreshTokenSubject = new BehaviorSubject<string | null>(null);

    get isRefreshing(): boolean {
        return this._isRefreshing;
    }

    set isRefreshing(value: boolean) {
        this._isRefreshing = value;
    }

    get refreshTokenSubject(): BehaviorSubject<string | null> {
        return this._refreshTokenSubject;
    }

    reset(): void {
        this._isRefreshing = false;
        this._refreshTokenSubject.next(null);
    }
}
